import { useQuery } from "@tanstack/react-query";
import { getPhotoUrl } from "../../../common/utils/getPhotoUrl";
import { getChatRooms, getUserInfoByUuids } from "../apis/chatApi";
import { set as setCachedUser } from "../stores/userDisplayUtils";
import {
  deriveRoomDisplayNames,
  roomListToListItems,
} from "../utils/roomListMapping";

async function fetchChatRoomListItems() {
  const res = await getChatRooms();
  const list = Array.isArray(res) ? res : (res?.rooms || res?.data || []);
  const myId = typeof window !== "undefined" ? window.loggedInUser?.uuid : null;

  const otherIds = [
    ...new Set(
      list
        .flatMap((r) => (r.members || []).map((m) => m.userId))
        .filter((id) => id && id !== myId)
    ),
  ];
  if (otherIds.length) {
    const users = await getUserInfoByUuids(otherIds);
    users.forEach((u) => {
      if (u.uuid)
        setCachedUser(u.uuid, {
          name: u.name || null,
          photo: getPhotoUrl(u.photo, "agent"),
        });
    });
  }

  const withNames = deriveRoomDisplayNames(list, myId);
  return roomListToListItems(withNames);
}

export const chatRoomsQueryKey = ["chatRooms"];

export function useChatRoomsLoad() {
  return useQuery({
    queryKey: chatRoomsQueryKey,
    queryFn: fetchChatRoomListItems,
    staleTime: 0,
  });
}
